import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import useUserStore from "../../../stores/userStore";
import { useAppStore } from "../../../stores/appStore";
import { BlockModalWrapper } from "../../../components/block-modal-wrapper/block-modal-wrapper";
import { ButtonOutlined } from "../../../components/button-outlined/button-outlined";
import {
  formControlStyles,
  formControlFocusStyles,
  selectStyles,
  inputLabelStyles,
  menuItemStyles,
  buttonBoxStyles,
} from "./styles";

export const SettingsDomain: React.FC = () => {
  const { focus, domain } = useAppStore();
  const { domainTree, fetchDomainTree, setServDomainFocus } = useUserStore();
  const { setIsPreassessmentOpen, setIsBrowserLocked, isAssessmentOpen } =
    useAppStore();
  const [selectedDomain, setSelectedDomain] = useState(domain);
  const [selectedFocus, setSelectedFocus] = useState(focus);

  useEffect(() => {
    fetchDomainTree();
  }, [fetchDomainTree]);

  const handleDomainChange = (event: SelectChangeEvent<string>) => {
    const newDomain = event.target.value;
    setSelectedDomain(newDomain);
    setSelectedFocus("");
  };

  const handleFocusChange = (event: SelectChangeEvent<string>) => {
    setSelectedFocus(event.target.value);
  };

  const handleSave = () => {
    if (isAssessmentOpen) return;
    setServDomainFocus(selectedDomain, selectedFocus);
    setIsPreassessmentOpen(false);
    setIsBrowserLocked(false, false);
  };

  const isSaveDisabled =
    isAssessmentOpen ||
    !selectedFocus ||
    (selectedDomain === domain && selectedFocus === focus);

  return (
    <BlockModalWrapper lable={"Focus & Domain"} isColumn={true}>
      <FormControl variant="outlined" sx={formControlStyles}>
        <InputLabel id="domain-select-label" sx={inputLabelStyles}>
          Domain
        </InputLabel>
        <Select
          labelId="domain-select-label"
          value={selectedDomain}
          onChange={handleDomainChange}
          label="Domain"
          sx={selectStyles}
        >
          {Object.keys(domainTree).map((domain) => (
            <MenuItem key={domain} value={domain} sx={menuItemStyles}>
              {domain}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectedDomain && (
        <FormControl variant="outlined" sx={formControlFocusStyles}>
          <InputLabel id="focus-select-label" sx={inputLabelStyles}>
            Focus
          </InputLabel>
          <Select
            labelId="focus-select-label"
            value={selectedFocus}
            onChange={handleFocusChange}
            label="Focus"
            sx={selectStyles}
            renderValue={(value) =>
              domainTree[selectedDomain]?.find((item) => item.focus === value)
                ?.treatment_name || value
            }
          >
            {(domainTree[selectedDomain] || []).map((focusItem) => (
              <MenuItem
                key={focusItem.focus}
                value={focusItem.focus}
                sx={menuItemStyles}
              >
                {focusItem.treatment_name || focusItem.focus}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Box sx={buttonBoxStyles}>
        <ButtonOutlined
          variant="outlined"
          disabled={isSaveDisabled}
          onClick={handleSave}
        >
          Save
        </ButtonOutlined>
      </Box>
    </BlockModalWrapper>
  );
};
